import React from 'react';
import styled from '../../styled';
import { COLORS } from '../../themes/color';

export const ChatWindow = styled('div')<{ $compact?: boolean }>`
  border-radius: ${(p) => (p.$compact ? '14px' : '18px')};
  overflow: hidden;
  background: ${COLORS.WHITE};
  border: 1px solid ${COLORS.GRAY.border};
  box-shadow: ${(p) =>
    p.$compact
      ? '0 8px 28px rgba(14, 28, 43, 0.06)'
      : '0 12px 40px rgba(14, 28, 43, 0.08)'};
`;

export const ChatHeader = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  border-bottom: 1px solid ${COLORS.GRAY.borderLight};
`;

export const ChatAvatar = styled('div')`
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: ${COLORS.WHITE};
  color: ${COLORS.PRIMARY};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${COLORS.GRAY.border};

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const ClientAvatar = styled('div')`
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ClientLogo = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const ChatHeaderName = styled('div')`
  font-size: 13px;
  font-weight: 700;
  color: ${COLORS.INK};
`;

export const ChatHeaderStatus = styled('div')`
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: ${COLORS.GRAY.muted};

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${COLORS.GREEN.green6};
    box-shadow: 0 0 6px rgba(82, 196, 26, 0.7);
  }
`;

export const ChatBody = styled('div')<{ $compact?: boolean }>`
  padding: ${(p) => (p.$compact ? '14px' : '18px')};
  display: flex;
  flex-direction: column;
  gap: ${(p) => (p.$compact ? '10px' : '14px')};
`;

export const UserBubbleRow = styled('div')`
  display: flex;
  justify-content: flex-end;
`;

export const UserBubble = styled('div')<{
  $compact?: boolean;
}>`
  max-width: ${(p) => (p.$compact ? '92%' : '88%')};
  background: ${COLORS.PRIMARY};
  color: ${COLORS.WHITE};
  padding: ${(p) => (p.$compact ? '8px 12px' : '10px 14px')};
  border-radius: 16px 16px 4px 16px;
  font-size: ${(p) => (p.$compact ? '13.5px' : '14.5px')};
  line-height: 1.5;
`;

export const AssistantBubbleRow = styled('div')`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

export const AssistantBubble = styled('div')<{ $compact?: boolean }>`
  max-width: 92%;
  background: ${COLORS.GRAY.surface};
  border: 1px solid ${COLORS.GRAY.border};
  color: ${COLORS.GRAY.body};
  padding: ${(p) => (p.$compact ? '10px 12px' : '12px 14px')};
  border-radius: 4px 16px 16px 16px;
  font-size: ${(p) => (p.$compact ? '13.5px' : '14.5px')};
  line-height: 1.6;
`;

export const ReportChip = styled('span')`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: 8px;
  font-size: 13px;
  font-weight: 600;
  color: ${COLORS.PRIMARY};
`;

type ChatClient = {
  name: string;
  logo: string;
};

type ChatExchangeProps = {
  client: ChatClient;
  prompt: string;
  response: React.ReactNode;
  compact?: boolean;
};

export const ChatExchange = ({
  client,
  prompt,
  response,
  compact
}: ChatExchangeProps) => (
  <>
    <UserBubbleRow>
      <UserBubble $compact={compact}>{prompt}</UserBubble>
    </UserBubbleRow>
    <AssistantBubbleRow>
      <ClientAvatar>
        <ClientLogo src={client.logo} alt="" />
      </ClientAvatar>
      <AssistantBubble $compact={compact}>{response}</AssistantBubble>
    </AssistantBubbleRow>
  </>
);
